import React from "react"
import ErrorRates from './components/ErrorRates'
import FinancialStats from './components/FinancialStats'

const Stats = ({ customer }) => {
    return (
        <div className="p-4 text-center space-y-2 bg-gray-50">
            <ErrorRates customer={customer}/>
            <FinancialStats customer={customer}/>
        </div>
    )
}

export default Stats
